import { ISlotData, TContainerLengths } from "open-vessel-definition";

import { ISlotPattern } from "./types/IPositionPatterns";

/** Calculates all the sizes defined by slots */
export function getSizesFromSlots(
  perSlotInfo:
    | {
        [key: ISlotPattern]: ISlotData;
      }
    | undefined,
): { sizes: TContainerLengths[]; definedSlots: number } {
  if (!perSlotInfo) return { sizes: [], definedSlots: 0 };

  const slotKeys = Object.keys(perSlotInfo) as ISlotPattern[];
  const allSizes = new Set<TContainerLengths>();
  let definedSlots = 0;

  slotKeys.forEach((key) => {
    if (perSlotInfo[key].restricted) {
      return;
    }

    const perSlotSizes = perSlotInfo[key].sizes;
    if (perSlotSizes) {
      (Object.keys(perSlotSizes) as unknown as TContainerLengths[]).forEach(
        (s) => allSizes.add(Number(s) as TContainerLengths),
      );
      definedSlots++;
    }
  });

  return {
    sizes: Array.from(allSizes) as TContainerLengths[],
    definedSlots,
  };
}

export function getSizesFromSlotDataArray(
  slotsData: ISlotData[],
): TContainerLengths[] {
  if (!slotsData || slotsData.length === 0) return [];

  const allSizes = new Set<TContainerLengths>();

  slotsData.forEach((slotData) => {
    const perSlotSizes = slotData.sizes;
    if (perSlotSizes) {
      (Object.keys(perSlotSizes) as unknown as TContainerLengths[]).forEach(
        (s) => allSizes.add(Number(s) as TContainerLengths),
      );
    }
  });

  return Array.from(allSizes) as TContainerLengths[];
}
